import { render, staticRenderFns } from "./cell.vue?vue&type=template&id=10cfabfd&lang=pug&"
import script from "./cell.vue?vue&type=script&lang=js&"
export * from "./cell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports